/* src/app/contract/contract-fixed-by-site-form/contract-fixed-by-site-form.component.css */
:host ::ng-deep .p-dropdown {
  width: 100% !important;
  max-width: 100% !important;
}
:host ::ng-deep .p-dropdown-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/*# sourceMappingURL=contract-fixed-by-site-form.component-P25F3XOA.css.map */
